/**
 * Return the country which is set by the environment or returns the default "de"
 */

export function getCountryCode(full: boolean = false): string {
  if (full) {
    return process.env.NUXT_ENV_DEFAULT_CODE || 'de'
  } else {
    return (process.env.NUXT_ENV_DEFAULT_CODE || 'de').substring(0, 2)
  }
}
